module.exports = fox._r("images/photo-placeholder.gif", __webpack_public_path__ + "images/photo-placeholder.gif");


//////////////////
// WEBPACK FOOTER
// ./images/photo-placeholder.gif
// module id = 68
// module chunks = 4